import React from 'react';
import { Link } from 'react-router';
import { connect } from 'react-redux';
import Paper from 'material-ui/Paper';
import TextField from 'material-ui/TextField';
import RaisedButton from 'material-ui/RaisedButton';
import HeaderSmall from '../Components/Header/HeaderSmall';
import { setPassword }  from '../actions/authActions';

const style = {
	minHeight: 200,
	height: 'auto',
	minWidth: 275,
	width: 'auto',
	padding:15
};

class PasswordChangePage extends React.Component {

    constructor(props) {
		super(props);
		this.state = {
			OldPassword: "",
			Password: "",
			ConfirmPassword: ""
		};
    }

   	setPassword = () => {

		
        
		const creds = { 
			Email: this.props.member.EmailAddress.trim(), 
			OldPassword: this.state.OldPassword.trim(), 
			Password: this.state.Password.trim(), 
			ConfirmPassword: this.state.ConfirmPassword.trim()
		}
		this.props.onSetPasswordClick(creds);
    }

    
    oldPasswordChange = (event) => {
        this.setState({ OldPassword: event.target.value });
    }

    passwordChange = (event) => {
        this.setState({ Password: event.target.value });
    }

    confirmPasswordChange = (event) => {
        this.setState({ ConfirmPassword: event.target.value });
    }

  	render() {

		return (
			<div>
				<HeaderSmall title="Change Password" />
				<div className="container" >
					<br />
					<Paper style={style} zDepth={1} >
						<div className="container" >
							<TextField 
								hintText="Old Password" 
								value={this.state.OldPassword} 
								onChange={this.oldPasswordChange} 
								type="password" 
							/>
							<br />
							<br />
							<TextField 
								hintText="New Password" 
								value={this.state.Password} 
								onChange={this.passwordChange} 
								type="password" 
							/>
							<br />
							<br />
							<TextField 
								hintText="Re-enter New password" 
								value={this.state.ConfirmPassword} 
								onChange={this.confirmPasswordChange} 
								type="password" 
							/>
							<br />
							<br />
							<br />
						</div>
					</Paper>
					<br />
					<br />
					<RaisedButton
						disabled={!(this.state.OldPassword !== '' && this.state.Password !== '' && this.state.ConfirmPassword === this.state.Password)}						label="Reset Password"
						primary={true}
						fullWidth={true}
						onClick={this.setPassword}
					>
					</RaisedButton>
					<br />
					<br />
				</div>
			</div>
    	);
  	}
};

const mapDispatchToProps = (dispatch) => {
  	return {
		onSetPasswordClick: (creds) => {
			dispatch(setPassword(creds))
		}
  	}
}

function mapStateToProps(state) {
    const { errorMessage, successMessage, isFetching } = state.thisApp.auth
    const member = state.thisApp.auth.member

	return {
		successMessage,
		errorMessage,
		isFetching,
		member
	}
}

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(PasswordChangePage);





// WEBPACK FOOTER //
// ./src/Pages/PasswordChange.js